import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress';
import TablePagination from '@material-ui/core/TablePagination'

import TablePaginationActions from '../common/TablePaginationActions'

import {
	getOrderItemList,
} from '../../actions/asyncOrders'

class OrderItemList extends Component {
	constructor() {
		super()
		this.state = {
			page: 0,
		}
	}
	componentDidMount() {
		this.getOrderItemList()
	}

	getOrderItemList = () => {
		const { orderId } = this.props
		const { page } = this.state
		this.props.getOrderItemList(orderId, page + 1)
	}

	handleChangePage = (newPage) => {
		this.setState({ page: newPage }, () => {
			this.getOrderItemList()
		})
	}

	render() {
		const { isLoading, orderItemList } = this.props
		const { page } = this.state

		if (isLoading) {
			return (
				<CircularProgress color="primary" />
			)
		}

		return (
			<Grid container spacing={2} className="order-item-list">
				{orderItemList.get('list').map(wine => (
					<Grid key={wine.get('code')} item container xs={3} direction="column">
						<Grid item
							className="wine-img"
							style={{
								backgroundImage: `url(${wine.get('imageUrl')})`,
							}}
						/>
						<Grid item>
							<Typography className="text-center text-grey">
								{wine.get('code')}
							</Typography>
						</Grid>
					</Grid>
				))}
				<Grid container>
					<TablePagination
						className="pagination"
						rowsPerPageOptions={[]}
						labelDisplayedRows={() => null}
						count={orderItemList.getIn(['pagination','totalCount'])}
						rowsPerPage={16}
						page={page}
						onChangePage={this.handleChangePage}
						ActionsComponent={TablePaginationActions}
					/>
				</Grid>
			</Grid>
		)
	}
}

OrderItemList.propTypes = {
	orderId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

const mapStateToProps = state => ({
	isLoading: state.orders.isOrderItemListLoading,
	orderItemList: state.orders.orderItemList,
})

const mapDispatchToProps = {
	getOrderItemList,
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderItemList)
